export const TRANSITION_DURATION = 300;
export const Z_INDEX = 50;
